import { Component, EventEmitter, OnInit, Output, Pipe, PipeTransform } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { ProfileService } from '../services/profile.service';
import { NotificationService } from '../services/notification.service';
import { environment } from '../../../environments/environment';
import { UtilityService } from '../services/utility.service';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    standalone: false
})
export class NotificationsComponent implements OnInit {
       
    constructor(
        public auth: AuthenticationService,
        public utility: UtilityService,
        public notificationService: NotificationService
    ) { }

    ngOnInit() {
    }

   
}

